import React from 'react'
import styled, { keyframes } from 'styled-components'

const LoaderAnime = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0.1;
    transform: translateY(-1rem);
  }
`

const Loader = styled.div`
  display: flex;
  justify-content: center;
  animation: ${LoaderAnime} 0.6s infinite alternate;
`

const LoaderDiv = styled.div`
  width: 1rem;
  height: 1rem;
  margin: 3rem 0.2rem;
  background: #8385aa;
  border-radius: 50%;
  animation: ${LoaderAnime} 0.6s infinite alternate;
  animation-delay: ${props => (props.delay ? props.delay : null)};
`

class BouncingLoader extends React.Component {
  render () {
    return <Loader>
      <LoaderDiv />
      <LoaderDiv delay='0.2s' />
      <LoaderDiv delay='0.4s' />
    </Loader>
  }
}

export default BouncingLoader
